import React from "react";
import teams_tab_data from "../data/TEAMS_TAB_DATA.json";
import ImageDisplay from "./ImageDisplay";
import ProfileModal from "./ProfileModal";

export interface TeamMember {
  name: string;
  title: string;
  profileSrc: string;
  profileBannerSrc: string;
  profileBannerPosition?: string;
  description: string;
}

interface TeamsTabData {
  teamMembers: TeamMember[];
}

const TeamsTab = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedMember, setSelectedMember] = React.useState<TeamMember>(null);

  const teamsData = teams_tab_data as TeamsTabData;
  return (
    <div className="space-y-4">
      <div className="flex justify-center items-center gap-2">
        <h2 className="text-xl font-bold">Our Team</h2>
      </div>

      <div className="grid grid-cols-3 gap-4 lg:gap-8">
        {teamsData.teamMembers.map((member, index) => (
          <ImageDisplay
            key={index}
            profile={member}
            onClick={(member) => {
              setIsModalOpen(true);
              setSelectedMember(member);
            }}
          />
        ))}
      </div>

      <ProfileModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedMember={selectedMember}
      />
    </div>
  );
};

export default TeamsTab;
